import { useState, useEffect } from "react";

export const useFullscreen = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Uppdatera state när fullskärmsstatus ändras
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    
    // Lyssna efter F11-tangenten för att upptäcka när användaren använder 
    // webbläsarens inbyggda fullskärmsläge
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "F11") {
        e.preventDefault(); // Hindra webbläsarens standardbeteende
        toggleFullscreen(); // Använd vår egen fullskärmshantering
      }
    };
    
    document.addEventListener("keydown", handleKeyDown);
    
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Växla fullskärmsläge
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(err => {
        console.error(`Kunde inte aktivera fullskärmsläge: ${err.message}`);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen().catch(err => {
          console.error(`Kunde inte avsluta fullskärmsläge: ${err.message}`);
        });
      }
    }
  };

  // Gå till fullskärm
  const enterFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(err => {
        console.error(`Kunde inte aktivera fullskärmsläge: ${err.message}`);
      });
    }
  };

  // Avsluta fullskärm
  const exitFullscreen = () => {
    if (document.fullscreenElement && document.exitFullscreen) {
      document.exitFullscreen().catch(err => {
        console.error(`Kunde inte avsluta fullskärmsläge: ${err.message}`);
      });
    }
  };

  return {
    isFullscreen,
    toggleFullscreen,
    enterFullscreen,
    exitFullscreen
  };
};

export default useFullscreen;